module.exports = __webpack_public_path__ + "img/new_devices.64f112c5.png";